import ChatIcon from '../../components/icons/navbar/ChatIcon'
import FinanceIcon from '../../components/icons/navbar/FinanceIcon'
import HomeIcon from '../../components/icons/navbar/HomeIcon'
import HumanResourceIcon from '../../components/icons/navbar/HumanResourceIcon'
import ImagesIcon from '../../components/icons/navbar/ImagesIcon'
import MarketingIcon from '../../components/icons/navbar/MarketingIcon'
import SalesIcon from '../../components/icons/navbar/SalesIcon'
import WorkflowIcon from '../../components/icons/navbar/WorkflowIcon'
import ClockIcon from '../../components/icons/navbar/ClockIcon'
import ProjectIcon from '../../components/icons/navbar/ProjectIcon'
import RealEstateIcon from '../../components/icons/navbar/RealEstateIcon'
import {hasPermission, SidebarPermission} from '../../../white-label/permission'
import {getCurrentDomainName} from '../../../utils/http/domain'

const arr = [
  {
    id: 1,
    groupName: 'main links',
    navs: [
      {
        id: 11,
        name: 'Home',
        Img: HomeIcon,
        disabled: false,
        url: '',
        quickAccess: false,
        parentRoute: '',
        lang_key: 'home',
      },
    ],
  },

  {
    id: 2,
    groupName: 'workflows',
    lang_key: 'workflows',
    navs: [
      {
        id: 21,
        name: 'Marketing',
        Img: MarketingIcon,
        disabled: false,
        url: 'marketing',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'marketing',
      },

      {
        id: 22,
        name: 'Sales',
        Img: SalesIcon,
        disabled: false,
        url: 'sales',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'sales',
      },

      {
        id: 23,
        name: 'Human Resource',
        Img: HumanResourceIcon,
        disabled: false,
        url: 'human-resource',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'human_resource',
      },

      {
        id: 24,
        name: 'Finance',
        Img: FinanceIcon,
        disabled: false,
        url: 'finance',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'finance',
      },
      {
        id: 25,
        name: 'Real Estate',
        Img: RealEstateIcon,
        disabled: false,
        url: 'real-estate',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'real_estate',
      },
    ],
  },

  {
    id: 3,
    groupName: 'generate',
    lang_key: 'generate',
    navs: [
      {
        id: 31,
        name: 'Chat',
        Img: ChatIcon,
        disabled: false,
        url: 'chat',
        quickAccess: false,
        parentRoute: '',
        lang_key: 'chat',
      },

      {
        id: 32,
        name: 'Images',
        Img: ImagesIcon,
        disabled: false,
        url: 'images',
        quickAccess: false,
        parentRoute: '',
        lang_key: 'images',
      },
    ],
  },
  {
    id: 4,
    groupName: 'more',
    lang_key: 'more',
    navs: [
      {
        id: 31,
        name: 'Recent Activity',
        Img: ClockIcon,
        disabled: false,
        url: 'recent_activity',
        quickAccess: true,
        parentRoute: '',
        lang_key: 'recent_activity',
      },
    ],
  },
]

export const getFilteredNavs = (domain: string) => {
  return arr
    .map((group) => ({
      ...group,
      navs: group.navs.filter((nav) => hasPermission(domain, nav.name as SidebarPermission)),
    }))
    .filter((group) => group.navs.length > 0)
}

export default getFilteredNavs(getCurrentDomainName())
